module.exports = __webpack_public_path__ + "img/button-get-started.94decdfe.png";